import { css } from "@microsoft/fast-element";
import { fontSizeBase300, fontWeightBold, spacingHorizontalXS, spacingHorizontalS, display, fontWeightRegular, fontSizeBase200, spacingVerticalXXS } from "@fluentui/web-components";
/** Card Header styles
 * @public
 */
export const styles = css `
  ${display("flex")}
  :host {
    position: relative;
    display: grid;
    grid-template-columns: min-content 1fr auto;
    padding: 6px;
    justify-content: flex-start;
  }

  ::slotted([slot="icon"]) {
    align-self: center;
  }
  ::slotted([slot="header"]) {
    font-size: ${fontSizeBase300};
    font-weight: ${fontWeightBold};
  }
  ::slotted([slot="action"]) {
    grid-column: 3;
    justify-self: flex-end;
  }
  ::slotted([slot="subtitle"]) {
    font-size: ${fontSizeBase200};
    font-weight: ${fontWeightRegular};
  }
  .header {
    justify-self: flex-start;
    display: flex;
    flex-direction: column;
    gap: ${spacingVerticalXXS};
  }
  .image {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-inline-end: ${spacingHorizontalS};
  }
  .row {
    display: flex;
    align-items: center;
    gap: ${spacingHorizontalXS};
  }
`;
//# sourceMappingURL=card-header.styles.js.map